import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { LoginInternalComponent } from './login/login-internal/login-internal.component';
import { LoginExternalComponent } from './login/login-external/login-external.component';
import { LoginGeneralComponent } from './login/login-general/login-general.component';
import {MockModule} from '../common/mock/modules/mock.module';
import {TranslateModule} from '../common/translate/translate.module';
import {TabStripModule} from '@progress/kendo-angular-layout';
import { LoginComponent } from './login/login-internal/login/login.component';
import {PatientSearchComponent} from './login/login-internal/patient.search/patient.search.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DateTimeModule} from '../common/datetime/datetime.module';
import {IntlModule} from '../common/intl/intl.module';
import {CommonComponentsModule} from "../common/components/common.components.module";
import {PatientAccountComponent} from "./login/login-internal/patient.account/patient.account.component";
import {PatientDetailsComponent} from "./login/login-internal/patient.details/patient.details.component";
import {SummaryComponent} from "./login/login-internal/summary/summary.component";
import {OneTimeCodeComponent} from "./login/login-internal/one.time.code/one.time.code.component";
import {WindowModule} from "@progress/kendo-angular-dialog";
import {RouterModule} from "@angular/router";
import {ClickableElementModule} from "../common/directives/clickable.element/clickable.element.module";
import {HideWhenPopupOpenModule} from "../common/directives/hide.when.popup.open/hide.when.popup.open.module";


@NgModule({
	declarations: [ LoginInternalComponent, LoginExternalComponent, LoginGeneralComponent, LoginComponent,
		PatientSearchComponent, PatientDetailsComponent, PatientAccountComponent, SummaryComponent, OneTimeCodeComponent],
	imports: [
		CommonModule,
		HttpClientModule,
		MockModule,
		TranslateModule,
		TabStripModule,
		ReactiveFormsModule,
		FormsModule,
		DateTimeModule,
		IntlModule,
		CommonComponentsModule,
		WindowModule,
		RouterModule,
		ClickableElementModule,
		HideWhenPopupOpenModule
	]
})
export class AppAuthModule { }

